import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import { PendingView, type RecentHistoryState } from './recentHistory.types';

const initialState: Partial<RecentHistoryState> = {
	pendingView: null
};

export const useRecentHistoryStore = create<RecentHistoryState>()(
	devtools(set => ({
		...initialState,

		setPendingView: (pendingView: PendingView) =>
			set({
				pendingView
			})
	}))
);
